/**
 * The mark: a speech bubble split like the board, one big tile and two small ones ("talk" laid out
 * as a treemap). The big piece is coral, the small ones pink and white (--logo-big,
 * --logo-top, --logo-bottom). Gaps are transparent, so it sits on any ground.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <path
        className="logo__big"
        d="M16 6H35V48H27L13 58L16 48A12 12 0 0 1 4 36V18A12 12 0 0 1 16 6Z"
      />
      <path className="logo__top" d="M39 6H48A12 12 0 0 1 60 18V28H39Z" />
      <path className="logo__bottom" d="M39 32H60V36A12 12 0 0 1 48 48H39Z" />
    </svg>
  );
}

/** Mark + name. */
export function Logo() {
  return (
    <>
      <LogoMark className="brand__mark" />
      <span className="brand__name">
        <b>talk</b> of the <b className="brand__town">town</b>
      </span>
    </>
  );
}
